var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMuseum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#8B7DBE",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.75-55.66v-93.01l82.86-.71v-371.08h-32.97q-21.45 0-35.67-15.48-14.22-15.47-14.22-37.01 0-18.28 9.31-33.98 9.31-15.7 24.11-26.58L428.72-871.3q11.32-7.8 24.52-11.96 13.2-4.16 26.63-4.16t26.76 4.16q13.33 4.16 25.48 11.96l338.38 237.79q14.14 11.57 23.53 26.97 9.39 15.4 9.39 34.59 0 21.78-14.3 36.63-14.3 14.86-35.6 14.86h-32.29v371.08l82.19.71v93.01H56.75ZM353.83-231.3q16.41 0 28.02-11.7 11.62-11.7 11.62-28.72v-130.35l49.79 74.25q5.78 9.89 15.93 15.17 10.15 5.28 20.78 5.28 10.92 0 20.81-4.95 9.88-4.94 16.63-14.83l49.79-74.92v130.35q0 17.02 11.73 28.72t28.8 11.7q16.41 0 28.02-11.7 11.62-11.7 11.62-28.72v-217.8q0-14.13-9.66-23.8-9.65-9.67-23.72-9.67h-29.43q-8.32 0-16.22 4-7.9 4.01-12.38 11.19L480-392.7l-73.96-112.68q-6.09-7.85-14.69-12.73-8.59-4.88-18.84-4.88h-18.63q-16.66 0-28.62 11.99-11.96 11.98-11.96 28.24v211.04q0 17.02 11.73 28.72t28.8 11.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuseum);
export default __webpack_public_path__ + "static/media/museum.a94f1ca014c9e28bbe1649b014642e93.svg";
export { ForwardRef as ReactComponent };